import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { marcarActaCargadaEnSinai, marcarActaEnSinaiSchema } from "./handlers";
import TextInput from "../../components/ReactHookForm/TextInput";
import MuniSpinner from "../../components/MuniSpinner";

const FormCargaEnSinai = (props) => {
  const { acta, setActa } = props;
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(marcarActaEnSinaiSchema),
    defaultValues: {
      id_acta: acta.id,
      numero_acta_sinai: acta.numero_acta,
    },
  });

  return (
    <Form onSubmit={handleSubmit((data) => marcarActaCargadaEnSinai(data, setActa, setIsLoading))}>
      <fieldset disabled={isLoading}>
        <TextInput
          name='numero_acta_sinai'
          label='Numero de Acta en SINAI *'
          register={register}
          errors={errors?.numero_acta_sinai}
          className='h-full'
          style={{ minHeight: "100px" }}
        />

        <TextInput
          name='observacion_carga_en_sinai'
          label='Observación *'
          register={register}
          errors={errors?.observacion_carga_en_sinai}
          className='h-full'
          style={{ minHeight: "100px" }}
        />

        <Button type='submit' variant='danger' className='mt-2'>
          {isLoading ? (
            <span className='d-flex gap-1'>
              <MuniSpinner
                width='18px'
                height='18px'
                circularProgressSize={24}
                circularProgressColor='#ffffff'
                fileName='bola-blanca.png'
              />
              Guardando
            </span>
          ) : (
            "Marcar como Cargada en SINAI"
          )}
        </Button>
      </fieldset>
    </Form>
  );
};

export default FormCargaEnSinai;
